import postal from 'postal';

export default function (message) {
  var channel = postal.channel('notification');
  channel.publish('notification.add', {
    message: message
  });
}



// WEBPACK FOOTER //
// ./src/helpers/sendNotification.js